/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Filter_ApproveInputs */

const vi_tea_purchase_filter_approve = /** @type {(inputs: Tea_Purchase_Filter_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phê duyệt`)
};

/**

* @param {Tea_Purchase_Filter_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_filter_approve = /** @type {((inputs?: Tea_Purchase_Filter_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Filter_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_filter_approve(inputs)
});